import { useEffect, useState } from "react";
import { Download, Share, Check } from "lucide-react";

function isStandalone() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
function isIos() {
  return /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
}

// Self-contained "Install app" control for Settings. Uses the native PWA prompt
// on Chrome/Android; falls back to iOS Safari "Add to Home Screen" instructions.
export default function InstallAppButton() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [iosHelp, setIosHelp] = useState(false);

  useEffect(() => {
    const onBip = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onBip);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBip);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      try { const { outcome } = await deferred.userChoice; if (outcome === "accepted") setInstalled(true); } catch { /* noop */ }
      setDeferred(null);
    } else {
      setIosHelp(true);
    }
  };

  if (installed) {
    return (
      <div className="flex items-center gap-3 p-6 text-sm text-[#59535B] dark:text-[#A298A6]" data-testid="install-already">
        <Check className="h-5 w-5 text-[#3D6B52]" /> Sisterhood+ is installed on this device.
      </div>
    );
  }

  return (
    <div className="p-6">
      <button data-testid="settings-install-app" onClick={install}
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-[#291B2D] text-[#FCFAF6] hover:bg-[#352238] px-6 py-3 text-sm font-medium dark:bg-[#C89B55] dark:text-[#291B2D]">
        <Download className="h-4 w-4" /> Add Sisterhood+ to your home screen
      </button>
      {(iosHelp || (isIos() && !deferred)) && (
        <p className="mt-3 text-sm text-[#59535B] dark:text-[#A298A6] leading-relaxed" data-testid="install-ios-help">
          On iPhone/iPad: tap the <Share className="inline h-4 w-4 mx-0.5" /> <strong>Share</strong> button in Safari,
          then choose <strong>“Add to Home Screen.”</strong>
        </p>
      )}
    </div>
  );
}
